import { render, staticRenderFns } from "./CategoryPreview.vue?vue&type=template&id=5f0c1164"
import script from "./CategoryPreview.vue?vue&type=script&lang=js"
export * from "./CategoryPreview.vue?vue&type=script&lang=js"
import style0 from "./CategoryPreview.vue?vue&type=style&index=0&id=5f0c1164&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports